/**
 * ============================================================
 * TRESTLE™ Workspace Utilities
 * ------------------------------------------------------------
 * Shared utility functions used throughout the Workspace.
 *
 * Brand        : Diafemme®
 * Module       : TRESTLE™ Workspace
 * File         : trestle-workspace-utils.js
 *
 * Version      : 1.0
 * Status       : PRODUCTION
 *
 * Responsibilities
 * ------------------------------------------------------------
 * • Date & Time Helpers
 * • Greeting Helpers
 * • Local Storage Helpers
 * • DOM Helpers
 * • Formatting Helpers
 * • Validation Helpers
 *
 * No API Calls
 * No Business Logic
 * No UI Rendering
 * ============================================================
 */

'use strict';

const TrestleUtils = (() => {

    /*==========================================================
    DATE & TIME
    ==========================================================*/

    function getCurrentDate() {

        return new Date();

    }

    function getTodayISO() {

        return new Date().toISOString().split("T")[0];

    }

    function getGreeting() {

        const hour = new Date().getHours();

        if (hour < 12) return "Good Morning";

        if (hour < 17) return "Good Afternoon";

        return "Good Evening";

    }

  
function formatTime(date = new Date()) {

    return date.toLocaleTimeString("en-IN", {

        hour: "2-digit",

        minute: "2-digit"

    });

}

function formatDate(date = new Date()) {

    return date.toLocaleDateString("en-IN", {

        day: "numeric",

        month: "long",

        year: "numeric"

    });

}

    /*==========================================================
    DOM HELPERS
    ==========================================================*/

    function get(id) {

        return document.getElementById(id);

    }

    function show(element) {

        if (element) {

            element.style.display = "";

        }

    }

    function hide(element) {

        if (element) {

            element.style.display = "none";

        }

    }

    function clear(element) {

        if (element) {

            element.innerHTML = "";

        }

    }

     /*==========================================================
    LOCAL STORAGE
    ==========================================================*/

    function save(key, value) {

        try {

            localStorage.setItem(

                key,

                JSON.stringify(value)

            );

            return true;

        }

        catch (error) {

            console.error(

                "Unable to save to Local Storage.",

                error

            );

            return false;

        }

    }



    function load(key) {

        try {

            const value = localStorage.getItem(key);

            return value

                ? JSON.parse(value)

                : null;

        }

        catch (error) {

            console.error(

                "Unable to load from Local Storage.",

                error

            );

            return null;

        }

    }



    function remove(key) {

        try {

            localStorage.removeItem(key);

            return true;

        }

        catch (error) {

            console.error(

                "Unable to remove Local Storage item.",

                error

            );

            return false;

        }

    }
    /*==========================================================
    VALIDATION
    ==========================================================*/

    function isEmpty(value) {

        return (

            value === null ||

            value === undefined ||

            value === ""

        );

    }

    function isArray(value) {

        return Array.isArray(value);

    }

    function isObject(value) {

        return (

            value !== null &&

            typeof value === "object"

        );

    }

    /*==========================================================
    FORMATTERS
    ==========================================================*/

    function capitalize(text = "") {

        if (!text.length) return "";

        return (

            text.charAt(0).toUpperCase() +

            text.slice(1)

        );

    }

    function truncate(text = "", length = 100) {

        if (text.length <= length) {

            return text;

        }

        return text.substring(0, length) + "...";

    }

    /*==========================================================
    UNIQUE ID
    ==========================================================*/

    function uuid() {

        return (

            Date.now().toString(36) +

            Math.random().toString(36).substring(2)

        );

    }

    /*==========================================================
    EXPORTS
    ==========================================================*/

    return {

        getCurrentDate,

        getTodayISO,

        getGreeting,

        formatDate,

        formatTime,

        get,

        show,

        hide,

        clear,

        save,

        load,

        remove,

        isEmpty,

        isArray,

        isObject,

        capitalize,

        truncate,

        uuid

    };

})();